<template>
  <div class="job-content">
    <div class="header-container">
      <span class="title">{{ $t(`${i18nKeyPrefix}.containerTitle.jobs`) }}</span>
      <SwitchButton
        class="switch-button"
        v-model="jobsType"
        :leftLabel="$t(`${i18nKeyPrefix}.btn.my`)"
        leftLabelValue="my"
        :rightLabel="$t(`${i18nKeyPrefix}.btn.all`)"
        rightLabelValue="all"
        @change="handelChangeTabStatus"
      />
    </div>
    <div class="filter-container">
        <el-select class="select company-select" :placeholder="$t(`${i18nKeyPrefix}.label.selectCompany`)" filterable v-model="selectCompany"  @change="handelChange">
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.i18nName"
            :value="item.id"
            :style="{'padding-left':item.level*15+'px'}"
          ></el-option>
        </el-select>
        <el-select class="select job-aging-type-select" v-model="jobAgingType" @change="handelChange">
          <el-option
            v-for="item in jobAgingTypeList"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    <div class="body-container">
      <div class="job-aging" >
        <div ref="job-aging-chart" class="job-aging-chart"></div>
      </div>
      <div class="job-numbers">
        <ul class="job-numbers-ul">
          <li v-for="(item, index) in initJobList" class="job-numbers-li" :key="index">
            <p class="name">{{ item.name }}</p>
            <span class="number">{{ item.number | formatBigNumber }}</span>
          </li>
          <li class="job-numbers-li add-jobs">
            <div class="add-jobs-a">
              <p class="add-jobs-text">{{ $t(`${i18nKeyPrefix}.message.jobsInfo.addJobs`) }}</p>
              <template v-if="canAddJob && hasJobCreatePermission && hasJobViewPermission">
                <i class="el-icon-circle-plus-outline"  @click="handelAddJob"></i>
              </template>
              <template v-else>
                <el-tooltip
                  effect="light"
                  popper-class="light-tooltip-popper add-btn-tooltip"
                  :content="$t(`${i18nKeyPrefix}.message.${hasJobCreatePermission && hasJobViewPermission ? 'jobCountNoEnough': 'hasNoPermission'}`)"
                >
                   <i class="disabled el-icon-circle-plus-outline"></i>
                </el-tooltip>
              </template>

            </div>
          </li>
        </ul>
      </div>
    </div>
    <RectLoading class="loading" v-show="loading"/>
  </div>
</template>

<script>
import _ from 'lodash'
import * as echarts from 'echarts'
import { mapActions, mapGetters } from 'vuex'
import mixin from './mixin'
import RectLoading from '@/components/loading/rectLoading.vue'
import SwitchButton from './switchButton.vue'

const CHART_OPTION = {
  tooltip: {
    trigger: 'item',
    position: function (pos, params, dom, rect, size) {
      const obj = {}
      obj[['right'][+(pos[0] < size.viewSize[0] / 2)]] = -pos[0] + 10
      obj[['top'][+(pos[0] < size.viewSize[1] / 2)]] = pos[1]
      obj[['left'][+(pos[0] > size.viewSize[0] / 2)]] = +pos[0] - 120
      obj[['top'][+(pos[0] > size.viewSize[1] / 2)]] = pos[1] + 10
      return obj
    },
    appendToBody: true
  },
  series: [
    {
      type: 'pie',
      radius: ['60%', '80%'],
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center'
      },
      color: ['#afdcef', '#c1c6e4', '#7899ce', '#94cb94'],
      emphasis: {
        label: {
          show: true,
          fontSize: '25',
          fontWeight: 'bold',
          formatter (val) {
            return Math.round(val.percent) + '%'
          }
        }
      },
      labelLine: {
        show: false
      },
      data: []
    }
  ]
}
let myChart

export default {
  mixins: [mixin],
  components: {
    SwitchButton,
    RectLoading
  },
  data () {
    const vm = this
    const i18nPrefix = 'admin.hrDashboard'
    return {
      i18nKeyPrefix: i18nPrefix,
      jobsType: 'my',
      jobAgingType: 'open',
      jobAgingTypeList: [
        {
          label: `${i18nPrefix}.label.open`,
          value: 'open'
        },
        {
          label: `${i18nPrefix}.label.all`,
          value: 'all'
        }
      ],
      selectCompany: '',
      addCompanyId: '',
      canAddJob: true,
      companyList: [],
      loading: false,
      jobsList: [
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobsInfo.jobsOpen`)
          },
          countName: 'opened_jobs_count',
          number: 0
        },
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobsInfo.jobsScreening`)
          },
          countName: 'screening_jobs_count',
          number: 0
        },
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobsInfo.interviewing`)
          },
          countName: 'interviewing_jobs_count',
          number: 0
        },
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobsInfo.jobsHired`)
          },
          countName: 'hired_and_onboard_jobs_count',
          number: 0
        },
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobsInfo.onHold`)
          },
          countName: 'onhold_jobs_count',
          number: 0
        }
      ],
      jobAgingList: [
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobAgingList.nameOne`)
          },
          countName: 'day_20',
          number: 0,
          color: '#afdcef'
        },
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobAgingList.nameTwo`)
          },
          countName: 'day_20_40',
          number: 0,
          color: '#c1c6e4'
        },
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobAgingList.nameThree`)
          },
          countName: 'day_40_60',
          number: 0,
          color: '#7899ce'
        },
        {
          get name () {
            return vm.$t(`${i18nPrefix}.message.jobAgingList.nameFour`)
          },
          countName: 'day_61',
          number: 0,
          color: '#94cb94'
        }
      ],
      eChartObj: {
        open: {},
        all: {}
      }
    }
  },
  computed: {
    initJobList: {
      get () {
        return this.jobsList
      },
      set (obj) {
        _.forEach(this.jobsList, (item, index) => {
          item.number = obj[`${item.countName}`]
        })
      }
    }
  },
  created () {
    this.initTabStatus()
    this.initCompanyList()
    this.initJobInfo()
  },
  mounted () {
    this.jobAgingChart()
  },
  methods: {
    ...mapActions('hrDashboard', ['getJobCountInfo', 'changeJobTabStatus']),
    ...mapGetters('hrDashboard', ['jobsTabStatus']),
    initTabStatus () {
      this.jobsType = this.jobsTabStatus()
    },
    async initJobInfo () {
      this.loading = true
      try {
        const resp = await this.getJobCountInfo({
          only_my_jobs: this.jobsType === 'my' ? '1' : '0',
          job_type: this.jobAgingType,
          company_id: this.selectCompany
        })
        if (resp && resp.job_agings) {
          this.canAddJob = resp.can_add_job
          this.addCompanyId = resp.add_company_id
          this.getJobAgingInfo(resp.job_agings)
          this.initJobList = resp
          this.generateJobAgingChart()
        }
      } finally {
        this.loading = false
      }
    },
    async initCompanyList () {
      this.companyList = await this.$parent.loadCompanyList()
    },
    getJobAgingInfo (list) {
      const currentObj = { day_20: 0, day_20_40: 0, day_40_60: 0, day_61: 0 }
      const allObj = _.clone(currentObj)
      list.forEach((item) => {
        if (item.current_status === '1') {
          if (item.opened_days <= 20) {
            currentObj.day_20 += 1
          } else if (item.opened_days > 20 && item.opened_days <= 40) {
            currentObj.day_20_40 += 1
          } else if (item.opened_days > 40 && item.opened_days <= 60) {
            currentObj.day_40_60 += 1
          } else {
            currentObj.day_61 += 1
          }
        }
        if (item.opened_days <= 20) {
          allObj.day_20 += 1
        } else if (item.opened_days > 20 && item.opened_days <= 40) {
          allObj.day_20_40 += 1
        } else if (item.opened_days > 40 && item.opened_days <= 60) {
          allObj.day_40_60 += 1
        } else {
          allObj.day_61 += 1
        }
      })
      this.eChartObj.open = currentObj
      this.eChartObj.all = allObj
    },
    generateJobAgingChart () {
      const allObj = this.eChartObj.all
      const currentObj = this.eChartObj.open
      const option = this.getJobsChartOption(this.jobAgingType === 'all' ? allObj : currentObj)
      this.jobAgingChart(option)
    },
    getJobsChartOption (obj) {
      let i = 0
      let isAllZero = 0
      const option = _.clone(CHART_OPTION)
      _.forEach(obj, (val, key) => {
        if (val) {
          isAllZero = isAllZero + 1
        }
        option.series[0].data[i] = {
          value: obj[key] || 0,
          name: this.jobAgingList[i].name
        }
        i++
      })
      if (isAllZero === 0) {
        option.series[0].color = 'rgb(247, 247, 247)'
      } else {
        option.series[0].color = ['#afdcef', '#c1c6e4', '#7899ce', '#94cb94']
      }
      return option
    },
    jobAgingChart (option = CHART_OPTION) {
      if (myChart !== null && myChart !== '' && myChart !== undefined) {
        myChart.dispose() // destroy
      }
      myChart = echarts.init(this.$refs['job-aging-chart'])
      myChart.setOption(option)
    },
    handelAddJob () {
      if (!this.hasJobCreatePermission) {
        this.$message.warning(this.$t(`${this.i18nKeyPrefix}.message.hasNoPermission`))
        return
      }
      let path = '/v-admin/job/add/?back=/v-admin/hr-dashboard/'
      if (this.addCompanyId || this.selectCompany) {
        path += `&company_id=${this.addCompanyId || this.selectCompany}`
      }
      this.$router.push(path)
    },
    handelChange () {
      this.initJobInfo()
    },
    handelChangeTabStatus () {
      this.initJobInfo()
      this.changeJobTabStatus(this.jobsType)
    }
  },
  watch: {
    '$i18n.locale' () {
      this.generateJobAgingChart()
    }
  }
}
</script>

<style lang="scss" scoped>
.job-content {
  background: #FFFFFF;
  border-radius: 6px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 15px;
  position: relative;

  .header-container {
    padding: 20px 24px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 18px;
      height: 25px;
      line-height: 25px;
      font-weight: bold;
    }

  }
  .filter-container {
    display: flex;
    align-items: center;
    padding-left: 24px;
    margin-bottom: 30px;

    .select {
      margin-right: 60px;
      height: 32px;
      width: 326px;

      ::v-deep .el-input {
        .el-input__inner {
          height: 32px;
          font-weight: 400;
          color: #909399;
        }
      }
    }
  }

  .body-container {
    display: flex;
    padding-bottom: 15px;

    .job-aging {
      width: 24%;
      border-right: 1px solid #DCDFE6;

      .job-aging-chart {
        flex: 1 0 auto;
        width: 119px;
        height: 122px;
        margin: 0 25% 0 23%;
      }
    }

    .job-numbers {
      width: 70%;
      padding: 0;

      .job-numbers-ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;

        .job-numbers-li {
          width: 30%;
          margin-bottom: 15px;
          display: flex;
          position: relative;
          text-align: center;
          flex-direction: column;
          align-items: center;

          .number {
            font-weight: bold;
            color: #303133;
            font-size: 22px;
            height: 30px;
            line-height: 30px;
            margin: 5px 0;
          }
          .name {
            line-height: 20px;
            margin: 0px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #909399;
          }
        }
        .add-jobs {
          .add-jobs-a {
            width: 100%;
            display: flex;
            flex-direction: column;
          }
          .add-jobs-text {
            margin: 0;
            color: #909399;
            font-weight: 400;
            transition: all 0.1s linear;
          }
          i {
            margin-top: 12px;
            font-size: 23px;
            color: #909399;
          }
        }
        .add-jobs:hover {
          i {
            color: #0296cc;
            cursor: pointer;

            &.disabled {
              color: #909399;
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }
}

#main {
  .loading.rect-loading  {
    position: absolute;
    &.loading-mask {
      z-index: 1;
    }
  }
}
</style>
